// src/components/FeatureSection.jsx
export default function FeatureSection() {
    const features = [
      {
        title: 'Invoice Generation',
        desc: 'Generate PDF invoices from JSON payloads in seconds. Fully customizable and easy to integrate.',
      },
      {
        title: 'PDF Merger',
        desc: 'Upload multiple PDFs and get back a single, clean file. Useful for report bundling, contracts, and automation flows.',
      },
      {
        title: 'PDF Field Extractor',
        desc: 'Send scanned or generated PDFs and get back structured data — ideal for invoice parsing, OCR workflows, or document agents.',
      },
      {
        title: 'LLM-Friendly JSON',
        desc: 'Each endpoint is structured to return clean, schema-safe JSON made for GPT agents.',
      },
      {
        title: 'Fast & Reliable',
        desc: 'Built in Go — optimized for speed, scalability, and production-grade workloads.',
      },
      {
        title: 'API-First by Design',
        desc: 'Every feature is designed to be headless, pluggable, and scalable — ideal for devs and automation workflows.',
      },
    ];
  
    return (
      <section className="py-24 px-6 text-white">
        <div className="max-w-5xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">What Makes InvokeApi Powerful</h2>
          <p className="text-lg text-gray-300">
            InvokeAPI gives your agents and apps instant access to production-ready endpoints — from invoice generation and PDF merging to receipt parsing and web scraping — all through simple API calls.
          </p>
        </div>
  
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white/5 border border-white/10 p-6 rounded-xl shadow hover:shadow-md transition duration-200"
            >
              <div className="mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-violet-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-1">{feature.title}</h3>
              <p className="text-sm text-gray-300">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>
    );
  }
  